webpackJsonp([16],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("j1ja");
module.exports = __webpack_require__("NHnr");


/***/ }),

/***/ "2mB4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-footer',{staticClass:"footer clear",attrs:{"height":"auto"}},[_c('div',{staticClass:"clear w1200"},[_c('div',{staticClass:"fl"},[_c('el-menu',{staticClass:"footerMenu",attrs:{"default-active":_vm.$route.path,"mode":"horizontal"},on:{"select":_vm.handleSelect}},[_c('el-menu-item',{attrs:{"index":"/news/news"}},[_c('a',{staticStyle:{"margin-left":"-10px"},attrs:{"href":"#/news/news"}},[_vm._v("新闻中心")]),_vm._v("|\n\t\t\t\t")]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"/job"}},[_c('a',{attrs:{"href":"#/job"}},[_vm._v("人才招聘")]),_vm._v("|")]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"/help"}},[_c('a',{attrs:{"href":"#/help"}},[_vm._v("帮助中心")]),_vm._v("|")]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":""}},[_c('a',{on:{"click":_vm.sendParams}},[_vm._v("联系我们")])]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"0"}},[_c('a',{attrs:{"href":"javascript:void(0)"}},[_c('img',{attrs:{"src":__webpack_require__("W3zg")}})])]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"1"}},[_c('a',{attrs:{"href":"javascript:void(0)"}},[_c('img',{attrs:{"src":__webpack_require__("YNx2")}})])]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"3"}},[_c('a',{attrs:{"href":"http://www.geotrust.com/ssl/","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__("oR6G")}})])])],1),_vm._v(" "),_c('p',[_vm._v("Copyright @ 盛迪嘉集团 - 深圳市盛迪嘉支付股份有限公司 ICP：粤B2-20130505 "),_c('a',{attrs:{"href":"http://beian.miit.gov.cn/"}},[_vm._v("备案号：粤ICP备13032423号")])]),_vm._v(" "),_c('p',[_c('a',{staticStyle:{"border":"0px","line-height":"20px","display":"inline-block","color":"#5f5e5e","padding-left":"0px"},attrs:{"target":"_blank","href":"http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030002010443"}},[_c('img',{staticStyle:{"vertical-align":"bottom","padding-right":"5px"},attrs:{"src":__webpack_require__("GO5g")}}),_vm._v("粤公网安备 44030002010443号\n\t\t\t\t")])])],1),_vm._v(" "),_c('div',{staticClass:"fr footer-lx"},[_c('div',{staticClass:"footer-phone fl"},[_c('img',{attrs:{"src":__webpack_require__("SzOy")}}),_vm._v(" "),_c('p',[_vm._v("4009-303-555"),_c('br'),_c('span',[_vm._v("周一至周日 9:00-22:00")])])]),_vm._v(" "),_c('p',{staticClass:"fl"},[_c('el-popover',{attrs:{"popper-class":"wxpop","trigger":"hover"}},[_c('img',{attrs:{"src":__webpack_require__("MHff")}}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("WraG")}}),_vm._v(" "),_c('el-button',{attrs:{"slot":"reference"},slot:"reference"},[_c('img',{attrs:{"src":__webpack_require__("eJX7")}}),_vm._v("关注微信公众号")])],1)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "51UM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AFB7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BXMg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BYAW":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/headphone-icon.8dfcb1b.png";

/***/ }),

/***/ "CpdA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {
			activeIndex: '1',
			//临时存放访问路径
			indexTemp: "1",
			posLogin: posLogin,
			person: person
		};
	},

	methods: {
		handleSelect: function handleSelect(key, keyPath) {
			console.log(key, keyPath);
			if (key === "/productDoc") {
				//无需选中样式
				this.$router.push({ path: "/" });
				return false;
			} else {
				this.indexTemp = key;
			}
		}
	}
});

/***/ }),

/***/ "GO5g":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ba-icon.d0289dc.png";

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("lRwf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    state: {
        loading: false,
        pickerOptions: {
            shortcuts: [{
                text: '今天', onClick: function onClick(picker) {
                    picker.$emit('pick', new Date());
                }
            }, {
                text: '昨天', onClick: function onClick(picker) {
                    var date = new Date();
                    date.setTime(date.getTime() - 3600 * 1000 * 24);
                    picker.$emit('pick', date);
                }
            }, {
                text: '一周前', onClick: function onClick(picker) {
                    var date = new Date();
                    date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit('pick', date);
                }
            }]
        },
        paginationPageSizes: [15, 30, 50, 100],
        paginationLayout: 'total, sizes, prev, pager, next, jumper'
    },
    mutations: {
        LOADING: function LOADING(state, loading) {
            state.loading = loading;
        }
    },
    actions: {
        Loading: function Loading(_ref, loading) {
            var commit = _ref.commit;

            commit('LOADING', loading);
        }
    }
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f23b049_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("NEom");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f23b049_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MHff":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/sdjqbapk.493c086.jpg";

/***/ }),

/***/ "N9+v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rel"},[_c('el-header',{staticClass:"doc-header",attrs:{"height":""}},[_c('div',{staticClass:"doc-header-meun clear"},[_c('p',{staticClass:"fl",staticStyle:{"height":"60px"}},[_c('a',{attrs:{"href":"#/"}},[_c('img',{attrs:{"src":__webpack_require__("gley")}})])]),_vm._v(" "),_c('el-menu',{staticClass:"meun fl el-menu-demo",attrs:{"default-active":_vm.$route.path,"mode":"horizontal"},on:{"select":_vm.handleSelect}},[_c('el-menu-item',{attrs:{"index":"/productDoc"}},[_c('a',{attrs:{"href":"#/productDoc"}},[_vm._v("产品文档")])]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"/apiDocBak"}},[_c('a',{attrs:{"href":"#/apiDocBak"}},[_vm._v("API文档")])]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"/techDoc"}},[_c('a',{attrs:{"href":"#/techDoc"}},[_vm._v("技术规范")])]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"/debugTool"}},[_c('a',{attrs:{"href":"#/debugTool"}},[_vm._v("开发&联调工具")])])],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NEom":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view',{attrs:{"id":"app"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("lRwf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui__ = __webpack_require__("l6IN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("OMN4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__("Zz1P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_polyfill__ = __webpack_require__("j1ja");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_head_vue__ = __webpack_require__("nW75");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_footer_vue__ = __webpack_require__("kQS1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_doc_head_vue__ = __webpack_require__("njAq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_font_awesome_css_font_awesome_min_css__ = __webpack_require__("e0XP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_font_awesome_css_font_awesome_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_font_awesome_css_font_awesome_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_index_css__ = __webpack_require__("tvR6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__app_less__ = __webpack_require__("X21A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__app_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__app_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_css_css_css__ = __webpack_require__("v4pY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_css_css_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_css_css_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_css_animate_min_css__ = __webpack_require__("AFB7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_css_animate_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_css_animate_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__App__ = __webpack_require__("M93x");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





/*头部-底部*/


/*文档头部*/








__WEBPACK_IMPORTED_MODULE_0_vue___default.a.config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_element_ui___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.prototype.$http = __WEBPACK_IMPORTED_MODULE_2_axios___default.a;





__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component('headMenu', __WEBPACK_IMPORTED_MODULE_5__views_head_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component('docHeadMenu', __WEBPACK_IMPORTED_MODULE_7__views_doc_head_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component('foo', __WEBPACK_IMPORTED_MODULE_6__views_footer_vue__["a" /* default */]);

new __WEBPACK_IMPORTED_MODULE_0_vue___default.a({
	el: '#app',
	router: __WEBPACK_IMPORTED_MODULE_13__router__["a" /* default */],
	store: __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */],
	render: function render(h) {
		return h(__WEBPACK_IMPORTED_MODULE_15__App__["a" /* default */]);
	}
});

__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('dateformat', function (dataStr) {
	var pattern = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY-MM-DD';

	return __WEBPACK_IMPORTED_MODULE_3_moment___default()(dataStr).format(pattern);
});
//点击跳转定位在顶部
__WEBPACK_IMPORTED_MODULE_13__router__["a" /* default */].beforeEach(function (to, from, next) {
	//	location.reload();
	// chrome
	document.body.scrollTop = 0;
	// firefox
	document.documentElement.scrollTop = 0;
	// safari
	window.pageYOffset = 0;
	next();
});

/***/ }),

/***/ "OMN4":
/***/ (function(module, exports) {

module.exports = axios;

/***/ }),

/***/ "SzOy":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/phone-icon.32917de.png";

/***/ }),

/***/ "VP9q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rel"},[_c('div',{staticClass:"head-tit clear"},[_c('div',{staticClass:"w1200 clear"},[_vm._m(0),_vm._v(" "),_c('a',{attrs:{"href":_vm.posLogin+'partner/jsp/loginagent.jsp',"target":"_blank"}},[_vm._v("代理商")]),_vm._v(" "),_c('span',{staticClass:"fl"},[_vm._v("|")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.person+'person',"target":"_blank"}},[_vm._v("个人")]),_vm._v(" "),_vm._m(1)])]),_vm._v(" "),_c('el-header',{staticClass:"header",attrs:{"height":""}},[_c('div',{staticClass:"header-meun clear"},[_c('p',{staticClass:"fl"},[_c('a',{attrs:{"href":"#/"}},[_c('img',{attrs:{"src":__webpack_require__("dLd/")}})])]),_vm._v(" "),_c('el-menu',{staticClass:"meun fl el-menu-demo",attrs:{"default-active":_vm.$route.path,"mode":"horizontal"},on:{"select":_vm.handleSelect}},[_c('el-menu-item',{attrs:{"index":"/"}},[_c('a',{attrs:{"href":"#/"}},[_vm._v("首页")])]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"/about"}},[_c('a',{attrs:{"href":"#/about"}},[_vm._v("关于我们")])]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"/product"}},[_c('a',{attrs:{"href":"#/product"}},[_vm._v("产品中心")])]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"/news/news"}},[_c('a',{attrs:{"href":"#/news/news"}},[_vm._v("新闻中心")])]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"/solve"}},[_c('a',{attrs:{"href":"#/solve"}},[_vm._v("解决方案")])]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"/cooperation"}},[_c('a',{attrs:{"href":"#/cooperation"}},[_vm._v("商务合作")])]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"/download"}},[_c('a',{attrs:{"href":"#/download"}},[_vm._v("下载中心")])])],1),_vm._v(" "),_c('div',{staticClass:"login-step fr"},[_c('a',{staticClass:"login-to",attrs:{"href":_vm.posLogin+'merchant/'}},[_c('img',{attrs:{"src":__webpack_require__("xoYE")}}),_vm._v("登录")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.posLogin+'merchant/#/register'}},[_vm._v("注册")])])],1)])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"fr",staticStyle:{"color":"#FF0000"}},[_c('img',{attrs:{"src":__webpack_require__("BYAW")}}),_vm._v(" 咨询热线：4009-303-555\n\t\t\t")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"javascript:void(0)"}},[_c('img',{staticStyle:{"width":"35px"},attrs:{"src":__webpack_require__("jAII"),"alt":""}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VdlM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {
			msg: 'contact'
		};
	},

	methods: {
		sendParams: function sendParams() {
			this.$router.push({
				path: '/about',
				params: {
					dataObj: this.msg
				},
				query: {
					dataObj: this.msg
				}
			});
		}
	}
});

/***/ }),

/***/ "W3zg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/zs-03.1e86eea.png";

/***/ }),

/***/ "WraG":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/sdjzf.bdd9420.jpg";

/***/ }),

/***/ "X21A":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YNx2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/zs-04.362093b.png";

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("lRwf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");



__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var NewsList = function NewsList(resolve) {
	__webpack_require__.e/* require */(12).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("1ScU")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var NewsListA = function NewsListA(resolve) {
	__webpack_require__.e/* require */(13).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("oJzq")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var Error = function Error(resolve) {
	__webpack_require__.e/* require */(14).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("a+KN")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var Index = function Index(resolve) {
	__webpack_require__.e/* require */(3).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("8hXn")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var ABouta = function ABouta(resolve) {
	__webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("oF1k")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var Product = function Product(resolve) {
	__webpack_require__.e/* require */(6).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("pGxt")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var Solve = function Solve(resolve) {
	__webpack_require__.e/* require */(8).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("0y0E")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var News = function News(resolve) {
	__webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("M6RC")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var NewsA = function NewsA(resolve) {
	__webpack_require__.e/* require */(9).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("z+1e")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var Down = function Down(resolve) {
	__webpack_require__.e/* require */(7).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("7RVW")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var Cooper = function Cooper(resolve) {
	__webpack_require__.e/* require */(5).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("ETWB")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var Job = function Job(resolve) {
	__webpack_require__.e/* require */(10).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("AeWm")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var Help = function Help(resolve) {
	__webpack_require__.e/* require */(11).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("NQGl")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var Register = function Register(resolve) {
	__webpack_require__.e/* require */(4).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("c2lw")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
// const productDoc = resolve=>{require(['@/views/doc/product_doc.vue'],resolve)};
// const apiDocBak = resolve=>{require(['@/views/doc/api_doc.vue'],resolve)};
// const techDoc = resolve=>{require(['@/views/doc/technical_specifications_doc.vue'],resolve)};
// const debugTool = resolve=>{require(['@/views/doc/debug_tool.vue'],resolve)};
var openDoc = function openDoc(resolve) {
	__webpack_require__.e/* require */(2).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("0JFm")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

var routes = [{ path: '/', component: Index, name: 'index', props: true }, { path: '/about', component: ABouta }, { path: '/product', component: Product }, { path: '/solve', component: Solve }, { path: '/news/news', component: News }, { path: '/news/newlist', component: NewsList }, { path: '/news/newsA', component: NewsA }, { path: '/news/newlistA', component: NewsListA }, { path: '/download', component: Down }, { path: '/cooperation', component: Cooper }, { path: '/job', component: Job }, { path: '/help', component: Help }, { path: '/register', component: Register }, { path: '/productDoc', component: openDoc }, { path: '/apiDoc', component: openDoc }, { path: '/techDoc', component: openDoc }, { path: '/debugTool', component: openDoc }, { path: '*', component: Error }, { path: '/openDoc', component: openDoc }];
var base = '/pay/';

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({ base: base, routes: routes });

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "Zz1P":
/***/ (function(module, exports) {

module.exports = moment;

/***/ }),

/***/ "dLd/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.e113b0b.png";

/***/ }),

/***/ "e0XP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eJX7":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/wx-gzh.dfc449a.png";

/***/ }),

/***/ "gley":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/doc_login.37ea553.png";

/***/ }),

/***/ "jAII":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/IPv6.b317aef.png";

/***/ }),

/***/ "kQS1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footer_vue__ = __webpack_require__("VdlM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6566d595_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__ = __webpack_require__("2mB4");
function injectStyle (ssrContext) {
  __webpack_require__("thVK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6566d595_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "l6IN":
/***/ (function(module, exports) {

module.exports = ELEMENT;

/***/ }),

/***/ "lRwf":
/***/ (function(module, exports) {

module.exports = Vue;

/***/ }),

/***/ "nW75":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_head_vue__ = __webpack_require__("CpdA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a4419ed_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_head_vue__ = __webpack_require__("VP9q");
function injectStyle (ssrContext) {
  __webpack_require__("51UM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_head_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a4419ed_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_head_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "njAq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_doc_head_vue__ = __webpack_require__("vgsN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e2a00b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_doc_head_vue__ = __webpack_require__("N9+v");
function injectStyle (ssrContext) {
  __webpack_require__("BXMg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_doc_head_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e2a00b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_doc_head_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oR6G":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/zs-06.6e5c4ca.png";

/***/ }),

/***/ "thVK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tvR6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "v4pY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vgsN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	methods: {
		handleSelect: function handleSelect(key, keyPath) {
			//				console.log(key, keyPath);
		}
	}
});

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app',
	mounted: function mounted() {
		var _this = this;

		function checkIE() {
			return '-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style;
		}
		if (checkIE()) {
			window.addEventListener('hashchange', function () {
				var currentPath = window.location.hash.slice(1);
				// alert(currentPath);
				if (_this.$route.path !== currentPath) {
					_this.$router.push(currentPath);
				}
			}, false);
		}
	}
});

/***/ }),

/***/ "xoYE":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/person-icon.0bd30c3.png";

/***/ })

},[0]);


// WEBPACK FOOTER //
// static/js/app.e9f49be1695943b3a07a.js